export default __webpack_public_path__ + "static/media/dispatched_hover_connected_selected.a0654a74.svg";